import AWS from "aws-sdk";

export const uploadS3Data = async (file, folder) => {
  const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
  const REGION = process.env.REACT_APP_AWS_S3_REGION;

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: REGION,
  });

  const ext = file.name.split(".").pop();
  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  try {
    const newFileName = `${Date.now()}.${ext}`;

    const params = {
      Bucket: S3_BUCKET, // ✅ only bucket name
      Key: `${folder}/${newFileName}`, // ✅ folder path
      Body: file,
      ACL: "public-read",
      ContentType: file.type,
      ContentDisposition: "inline",
    };

    return new Promise((resolve, reject) => {
      s3.putObject(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
          // ✅ return FULL URL instead of just file name
          resolve(
            `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${folder}/${newFileName}`
          );
        }
      });
    });
  } catch (error) {
    console.error("Error in UploadData:", error);
  }
};
